// extracted by mini-css-extract-plugin
module.exports = {"tiles":"EstatesView-module--tiles--254Mo"};